import { NotFoundComponent } from "./not-found/not-found.component";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

@NgModule({
  imports: [CommonModule, RouterModule],
  declarations: [NotFoundComponent]
})
export class NotFoundModule {}
